module.exports = "https://static.wanderu.com/static/media/apple-badge.8c4986ee.svg";